import * as React from 'react';

import { BackButton } from './BackButton';
import { useStepper } from '../../context';

export type HeaderProps = {
  title: string;
  description?: React.ReactNode;
};

function Header({ title, description }: HeaderProps) {
  const { currentStep, stepsLength } = useStepper();

  return (
    <header className='flex flex-col'>
      <BackButton />
      <span className='text-content-subtitle mt-2 mb-1 text-[[0.625rem] font-bold uppercase' aria-valuenow={currentStep}>
        Passo {currentStep} de {stepsLength}
      </span>
      <h2 id='step-title' className='text-primary leading-1.2 mb-2 text-[[2rem] font-semibold'>
        {title}
      </h2>
      {description && <p className='text-content-subtitle text-base'>{description}</p>}
    </header>
  );
}

export { Header };
